/* global moment */
angular
  .module('statEmployee')
  .component('statEmployee', {
    template: require('./stat-employee.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function StatEmployeeController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'stat';
        $rootScope.menu = 'employee';
        $scope.selectedCityId = '-1';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        this.target_month = moment().startOf('month').format('YYYY-MM');
        function processTotal(days) {
          const total = { doc_count: 0, sum_availability: 0, sum_workinghour: 0, sum_holidaycount: 0, sum_washcount: 0 };
          const total_working_day_only = { count: 0, doc_count: 0, sum_availability: 0, sum_workinghour: 0, sum_holidaycount: 0, sum_washcount: 0 }; // eslint-disable-line
          days.map((day) => {
            total.doc_count += day.doc_count;
            total.sum_availability += day.sum_availability.value;
            total.sum_workinghour += day.sum_workinghour.value;
            total.sum_holidaycount += day.sum_holidaycount.value;
            total.sum_washcount += day.sum_washcount.value;
            if (day.is_working_day.value) {
              total_working_day_only.doc_count += day.doc_count;
              total_working_day_only.sum_availability += day.sum_availability.value;
              total_working_day_only.sum_workinghour += day.sum_workinghour.value;
              total_working_day_only.sum_holidaycount += day.sum_holidaycount.value;
              total_working_day_only.sum_washcount += day.sum_washcount.value;
              total_working_day_only.count += 1;
            }
            return day;
          });
          return {
            days,
            total,
            total_working_day_only,
          };
        }

        $scope.reload = () => {
          $resource(`${APIURL}/admin/es/employee/availability/${this.target_month}`)
            .get({}).$promise
            .then((data) => {
              this.works = [
                { wash_start_hour: 7, data: processTotal(data.days_work_start_7) },
                { wash_start_hour: 10, data: processTotal(data.days_work_start_10) },
              ];
            });
        };

        $scope.onDatePick = () => {
          this.target_month = jQuery('#inputPickerFrom').val();
          $scope.reload();
        };

        this.viewDay = (target, washStartHour) => {
          $resource(`${APIURL}/admin/es/employee/availability/${moment(target).format('YYYY-MM/DD')}?wash_start_hour=${washStartHour}`)
            .get({}).$promise
            .then((data) => {
              console.log(data);
              this.dayData = data;
              jQuery('#modal-view-day').modal('show');
            });
        };
        this.requestUpdateWorkingDay = (workingDay) => {
          const target = moment(this.dayData.days[0].key_as_string).format('YYYY-MM/DD');
          $resource(`${APIURL}/admin/es/employee/availability/${target}/working_day`)
            .save({ working_day: workingDay }).$promise
            .then(() => {
              alert($translate.instant('수정되었습니다.'));
              $scope.reload();
              jQuery('#modal-view-day').modal('hide');
            });
        };

        $scope.reload();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/stat-employee/stat-employee.component.js